import { Button, Typography } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

function Projects({id}) {
    const navigate = useNavigate()
  return (
    <div>
        <Typography variant='h6'>Company Projects</Typography>
        <Button onClick={()=>navigate("/dashboard/createSite", {state: id})} >Create Project</Button>
    </div>
  )
}

export default Projects